import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X, Check } from 'lucide-react';
import { getConsent, setConsent, initGA } from '../utils/analytics';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (!consent) {
      // Léger délai pour ne pas bloquer le rendu initial
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
    if (consent === 'accepted') initGA();
  }, []);

  function accept() {
    setConsent('accepted');
    initGA();
    setVisible(false);
  }

  function refuse() {
    setConsent('refused');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Gestion des cookies"
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6"
    >
      <div className="max-w-4xl mx-auto glass border border-border/50 rounded-2xl shadow-2xl
        bg-background/95 backdrop-blur-xl px-6 py-5 flex flex-col md:flex-row
        items-start md:items-center gap-5">

        {/* Icône */}
        <div className="w-10 h-10 rounded-xl bg-primary/15 border border-primary/25
          flex items-center justify-center flex-shrink-0">
          <Cookie className="w-5 h-5 text-primary" />
        </div>

        {/* Texte */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground mb-1">
            Nous utilisons des cookies d'analyse
          </p>
          <p className="text-xs text-muted-foreground leading-relaxed">
            Google Analytics mesure l'audience de ce site (pages vues, sources de trafic).
            Vos données sont anonymisées. Vous pouvez refuser sans impact sur votre navigation.{' '}
            <Link to="/confidentialite" className="text-primary hover:underline">
              Politique de confidentialité
            </Link>
          </p>
        </div>

        {/* Boutons */}
        <div className="flex items-center gap-3 flex-shrink-0 w-full md:w-auto">
          <button
            onClick={refuse}
            className="flex-1 md:flex-none flex items-center justify-center gap-1.5
              px-4 py-2 rounded-lg border border-border/50 text-sm text-muted-foreground
              hover:text-foreground hover:border-border transition-colors">
            <X className="w-3.5 h-3.5" />
            Refuser
          </button>
          <button
            onClick={accept}
            className="flex-1 md:flex-none flex items-center justify-center gap-1.5
              px-5 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-medium
              hover:bg-primary/90 transition-colors glow-purple">
            <Check className="w-3.5 h-3.5" />
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
